var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgPuzzle = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8C3 7.44772 3.44772 7 4 7H6.71922C7.36979 7 7.85762 6.38154 7.84172 5.73116C7.81307 4.55964 8.12671 3 10 3C11.8733 3 12.1869 4.55964 12.1583 5.73116C12.1424 6.38154 12.6302 7 13.2808 7H16C16.5523 7 17 7.44772 17 8V10.7192C17 11.3698 17.6185 11.8576 18.2688 11.8417C19.4404 11.8131 21 12.1267 21 14C21 15.8733 19.4404 16.1869 18.2688 16.1583C17.6185 16.1424 17 16.6302 17 17.2808V20C17 20.5523 16.5523 21 16 21H13.2808C12.6302 21 12.1424 20.3815 12.1583 19.7312C12.1869 18.5596 11.8733 17 10 17C8.12671 17 7.81307 18.5596 7.84172 19.7312C7.85762 20.3815 7.36979 21 6.71922 21H4C3.44772 21 3 20.5523 3 20V17.2808C3 16.6302 3.61846 16.1424 4.26884 16.1583C5.44036 16.1869 7 15.8733 7 14C7 12.1267 5.44036 11.8131 4.26884 11.8417C3.61846 11.8576 3 11.3698 3 10.7192V8Z",
    fill: "#5A2FDE",
    stroke: "#5A2FDE",
    strokeWidth: 1.5
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPuzzle, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/puzzle.05c7eb94.svg";
export { ForwardRef as ReactComponent };